import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';
import { connect } from 'react-redux';

import {
  fetchCustomDomainInfo,
  clearCustomDomainInfo,
} from 'redux/settings/actions';

import {
  fetchMe,
} from 'redux/users/actions';

import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import './VerifyCustomDomain.css';

const VerifyCustomDomain = ({
  fetchCustomDomainInfo,
  clearCustomDomainInfo,
  fetchMe,
  me,
  customDomainInfo,
  customDomainInfoError,
}) => {

  const [verify, setVerify] = useState(false);

  useEffect(() => {
    if (customDomainInfo) {
      fetchMe();
    }
    return () => clearCustomDomainInfo();
  }, [customDomainInfo]);

  if (!me || (me && !me.custom_domain) || (me && me.custom_domain && me.custom_domain.is_verified)) {
    return null;
  }

  const handleVerify = () => {
    fetchCustomDomainInfo(me.custom_domain.id);
    setVerify(true);
  };

  return (
    <Translation>
      {(t) => (
        <div className="verify-custom-domain__component">
          <div className="verify-custom-domain-wrapper">
            <Button
              className="verify-custom-domain-button"
              onClick={() => { handleVerify(); }}
            >
              {t("Verify")}
            </Button>

            {(me && me.custom_domain && !me.custom_domain.is_verified) && verify &&
              <CommonMessage warning>
                <b>{t("Verification is in progress.")}</b>
                {t("It typically takes 5-10 minutes to update CNAME and TXT domain’s DNS records. Please reach out to")} <a href="mailto:team@heylink.me">team@heylink.me</a> {t("if there are any questions.")}
              </CommonMessage>
            }
          </div>
        </div>
      )}
    </Translation>
  );
};

VerifyCustomDomain.propTypes = {
  fetchCustomDomainInfo: PropTypes.func,
  clearCustomDomainInfo: PropTypes.func,
  fetchMe: PropTypes.func,
  me: PropTypes.object,
  customDomainInfo: PropTypes.object,
  customDomainInfoError: PropTypes.object,
};
VerifyCustomDomain.defaultProps = {
  fetchCustomDomainInfo: null,
  clearCustomDomainInfo: null,
  fetchMe: null,
  me: null,
  customDomainInfo: null,
  customDomainInfoError: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    customDomainInfo: state.settingsReducer.customDomainInfo,
    customDomainInfoError: state.settingsReducer.customDomainInfoError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCustomDomainInfo,
    clearCustomDomainInfo,
    fetchMe,
  },
)(VerifyCustomDomain);
